import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import DOMPurify from 'dompurify';
import 'react-quill-new/dist/quill.snow.css'; // 에디터로 쓴 서식(목록·정렬 등) 그대로 보이게
import { buildApiUrl } from '../config/api';
import '../styles/Common.css'; // 공통 스타일

const UpdateDetail = () => {
  const { id } = useParams();
  const [updateDetail, setUpdateDetail] = useState(null);

  useEffect(() => {
    axios.get(buildApiUrl(`/api/notice_list/${id}`))
      .then(response => {
        setUpdateDetail(response.data);
      })
      .catch(error => {
        console.error('Error fetching update detail:', error);
      });
  }, [id]);

  if (!updateDetail) {
    return <div>불러오는 중...</div>;
  }

  return (
    <div className="detail-container-full">
      <h1 className="detail-title">{updateDetail.Title}</h1>
      <p className="detail-date">
        작성일: {new Date(updateDetail.Write_DT).toLocaleDateString()}
      </p>
      <div className="ql-snow">
        <div className="detail-content ql-editor" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(updateDetail.Content || '') }} />
      </div>
    </div>
  );
};

export default UpdateDetail;
